module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ls-height-inherit ls-login-parent",
    attrs: {
      "id": "layout-admin"
    }
  }, [(!_vm.customerRoute) ? _c('div', [(_vm.isAuthenticated) ? _c('RootHeader', {
    attrs: {
      "popup": _vm.isPopup
    }
  }) : _vm._e(), _vm._v(" "), (_vm.wizardDone && _vm.isAuthenticated && !_vm.isPopup) ? _c('SideBar') : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('main', {
    class: [_vm.wizardDone && _vm.isAuthenticated && !_vm.customerRoute ? 'ls-main' : 'ls-main-full']
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('PageLoader'), _vm._v(" "), _c('router-view')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf8d179c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/layouts/admin.vue
// module id = 832
// module chunks = 1